/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { InViewObserver, site } from '@panel/commons/helpers';
import parser from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { sendEvent, calculatePriceWithTax } from '../../../../utils';
import {
  OnlyRentTag,
  PlanCard,
  PlanInner,
  PlanName,
  Price,
  PriceUpgrade,
  PlanDetailsContainer,
  Check,
  PlanDetails,
  BuyButton,
  PriceInfo,
  TopContainer,
  BottomContainer,
  ExtraInfo
} from '../styles';

const thresholds = new Array(21).fill(0).map((v, i) => (i * 0.05).toFixed(2));
const isPanamaOrEcuador = site.isPanama || site.isEcuador;

const CommonCards = ({
  products,
  isUpgrade,
  symbol,
  setScrollLimits,
  refe,
  handleEvent,
  handleProductSelection,
  propertyObj,
  operationTypeId,
  planName,
  subPropertyObj,
  isMobile
}) => {
  const { t } = useTranslation();
  const siteId = site.id;

  return (
    <>
      {products.map((card, i) => {
        return (
          <InViewObserver
            data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-observer`}
            key={`${card.id}-${i}`}
            id={`card-${i}`}
            as='div'
            onChange={(inView, entry) => {
              if (!inView || entry.intersectionRatio < 1.0) {
                setScrollLimits(refe);
              }
            }}
            threshold={thresholds}
          >
            <PlanCard
              data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}`}
              className={card.type.toUpperCase()}
              plan={card.type}
              id={card.id}
              upgrade={isUpgrade}
              siteId={siteId}
            >
              {siteId === 'ZPAR' && card.type.toUpperCase() === 'SIMPLE' && (
                <OnlyRentTag data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-onlyRentZPAR`}>
                  {t('publisher.step4.module1.only.rent')}
                </OnlyRentTag>
              )}
              <PlanInner data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-planInner`}>
                <TopContainer
                  data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-containerTop`}
                  upgrade={isUpgrade}
                >
                  <PlanName
                    data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-name`}
                    className={card.type.toUpperCase()}
                    upgradeName={isUpgrade}
                  >
                    {card.name}
                  </PlanName>
                  <Price
                    recurrenceAsterikOnly={isPanamaOrEcuador}
                    data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-price`}
                    oldPrice={isUpgrade}
                    isMobile={isMobile}
                  >
                    {isUpgrade && <hr />}
                    {card.formatUnitPrice && calculatePriceWithTax(card.formatUnitPrice, symbol, siteId)}
                    {!isPanamaOrEcuador ? (
                      card.frequencyKey.includes('quarterly') || card.frequencyKey.includes('monthly') ? (
                        <span>/ {card.renewalFrequency}*</span>
                      ) : (
                        <span>/ {card.renewalFrequency}</span>
                      )
                    ) : (
                      <span>*</span>
                    )}
                  </Price>
                  {isUpgrade && (
                    <>
                      <PriceUpgrade data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-price`}>
                        {card.formatUpgradeUnitPrice &&
                          calculatePriceWithTax(card.formatUpgradeUnitPrice, symbol, siteId)}
                        {card.formatUpgradeUnitPrice && <span>/ 1er mes*</span>}
                      </PriceUpgrade>
                      <PriceInfo data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-info`}>
                        {t('publisher.step4.module1.givePlan.upgrade')}
                        {planName}
                      </PriceInfo>
                    </>
                  )}
                </TopContainer>
                <PlanDetailsContainer
                  data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-detail`}
                  full={card.description.length > 2}
                  upgrade={isUpgrade}
                >
                  {card.description[0] && (
                    <div>
                      <Check
                        iconBenefit={isUpgrade ? 'file' : ''}
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-detail-check`}
                        upgrade={isUpgrade}
                      />
                      <PlanDetails
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-detail-duration`}
                        upgrade={isUpgrade}
                      >
                        {parser(card.description[0])}
                      </PlanDetails>
                    </div>
                  )}
                  {card.description[1] && (
                    <div>
                      <Check
                        iconBenefit={isUpgrade ? 'eye' : ''}
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-check`}
                        upgrade={isUpgrade}
                      />
                      <PlanDetails
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-detail`}
                        upgrade={isUpgrade}
                      >
                        {parser(card.description[1])}
                      </PlanDetails>
                    </div>
                  )}
                  {card.description[2] && (
                    <div>
                      <Check
                        iconBenefit={isUpgrade ? 'money' : ''}
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-check2`}
                        upgrade={isUpgrade}
                      />
                      <PlanDetails
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-detail`}
                        upgrade={isUpgrade}
                      >
                        {parser(card.description[2])}
                      </PlanDetails>
                    </div>
                  )}
                  {siteId === 'ZPAR' && card.type === 'SUPERHIGHLIGHTED' && card.description[3] && (
                    <div>
                      <Check
                        iconBenefit={isUpgrade ? 'money' : ''}
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-check3`}
                        upgrade={isUpgrade}
                      />
                      <PlanDetails
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-detail`}
                        upgrade={isUpgrade}
                      >
                        {parser(card.description[3])}
                      </PlanDetails>
                    </div>
                  )}
                  {siteId === 'ZPAR' && !isUpgrade && (
                    <div>
                      <PlanDetails
                        data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-tax-detail`}
                      >
                        {t('publisher.step4.module2.details.NoTaxes')} {<br />} {`${symbol} ${card.formatUnitPrice}`}
                      </PlanDetails>
                    </div>
                  )}
                </PlanDetailsContainer>
                <BottomContainer
                  data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-visibility-check`}
                >
                  {isPanamaOrEcuador && <ExtraInfo>{card.noteTaxes}</ExtraInfo>}
                  <BuyButton
                    data-repa={`step4module1-productsArea-planCard-${card.type.toUpperCase()}-button-buy`}
                    onClick={() => {
                      handleEvent(card, i);
                      handleProductSelection(card.id);
                      sendEvent(
                        'Planes Modulo1',
                        'Continuar',
                        operationTypeId,
                        propertyObj,
                        subPropertyObj,
                        card.name,
                        symbol + card.formatUnitPrice
                      );
                    }}
                  >
                    {isUpgrade ? t('publisher.step4.module1.upgrade.buy') : t('publisher.step4.module1.buy')}
                  </BuyButton>
                </BottomContainer>
              </PlanInner>
            </PlanCard>
          </InViewObserver>
        );
      })}
    </>
  );
};

export { CommonCards };
